export const PREDEFINED_MODEL_SCRIPT = `
export class Model extends ModelBase {

  onInit() {

  }
  
  onStart() {
    
  }

  onDestroy() {
    
  }

  onEnterRoom() {

  }

  onLeaveRoom() {

  }

  onVisible(visible: boolean) {

  }

  onClick(hitPoint: Readonly<flavr_math.Vector3>) {

  }

  onSelect() {

  }

  onDeselect() {

  }

  onEnterContact(otherUid: UID) {

  }

  onLeaveContact(otherUid: UID) {

  }

  onUpdate() {
    
  }
}`;
